export default {"src":"/_next/static/media/akkordeon.b2de8614.gif","height":524,"width":655,"blurWidth":0,"blurHeight":0};